import { QueryClient } from "@tanstack/react-query";

// Client provider for api(s)
export const queryClient = new QueryClient();
